import type {
  AuthUrlResponse,
  AvailableCalendarsResponse,
  CalendarPreferences,
} from '../types/calendar';
import { apiGet, apiPost } from './utils';

export const calendarAuthApi = {
  /**
   * Get Google OAuth authorization URL
   */
  async getAuthUrl(identity: string): Promise<string> {
    const response = await apiGet<AuthUrlResponse>('/calendar-auth/get-auth-url', {
      identity,
    });
    return response.authorization_url;
  },

  /**
   * Get list of available Google calendars for user
   */
  async getAvailableCalendars(identity: string): Promise<AvailableCalendarsResponse> {
    return apiGet<AvailableCalendarsResponse>(
      '/calendar-auth/google-available-calendars',
      { identity }
    );
  },

  /**
   * Add a calendar to the synced calendars list
   */
  async addSyncedCalendar(identity: string, calendar_id: string): Promise<boolean> {
    await apiPost('/calendar-auth/google-add-synced-calendar', {
      identity,
      calendar_id,
    });
    return true;
  },

  /**
   * Remove a calendar from the synced calendars list
   */
  async removeSyncedCalendar(identity: string, calendar_id: string): Promise<boolean> {
    await apiPost('/calendar-auth/google-remove-synced-calendar', {
      identity,
      calendar_id,
    });
    return true;
  },

  /**
   * Save calendar preferences
   */
  async setCalendarPreferences(preferences: string): Promise<string> {
    const response = await apiPost<CalendarPreferences>(
      '/calendar-auth/set-calendar-preferences',
      { preferences }
    );
    return response.preferences;
  },

  /**
   * Get calendar preferences
   */
  async getCalendarPreferences(): Promise<string> {
    const response = await apiGet<CalendarPreferences>(
      '/calendar-auth/get-calendar-preferences'
    );
    return response.preferences;
  },

  /**
   * Disconnect Google Calendar (remove credentials)
   */
  async disconnectCalendar(identity: string): Promise<boolean> {
    await apiPost('/calendar-auth/disconnect', { identity });
    return true;
  },
};
